import { ImParagraphCenter } from "react-icons/im";

export default function Logo() {
  return (
    <h1 className="alignCenter gap10">
      <ImParagraphCenter /> GesBolso
    </h1>
  );
}
